import { Options } from './wxOptions';

export enum DataType {
    // base types
    String = 0, // varchar/nvarchar
    Guid = 1, // uniqueidentifier
    Boolean = 2, // tinyint, boolean
    Indicator = 3, // smallint
    Integer = 4, // int, bigint
    Amount = 5, // decimal(x,y) money
    Float = 6, // decimal(x,y) normal
    Date = 7, // date field
    DateTime = 8, // datetime, smalldatetime
    Time = 9, // varchar(5)
    Duration = 10, // datetime (datepart not used)
    // complex type
    Text = 20, // text/ntext
    Base64 = 21, // resource
    // functional types
    Icon = 30, // varchar with icon-text
    Action = 31, // tinyint controlling
    IMEI = 32, // IMEI of mobile device
}
export enum ColumnAppearance {
    Hidden = 0, // non visible
    Visible = 1, // means unsorted
    Ascending = 2, // sorted ascending
    Descending = 3, // sorted descending
}

export enum WidgetAppearance {
    Hidden = 0,
    Visible = 1,
    Readonly = 1, // same meaning like visible
    Writable = 2,
    Required = 3,
}

export enum FieldAlignment {
    Left = 0,
    Right = 1, // means !Readonly
    Centered = 2,
}

export class FieldDesc {
    private xFieldName = '';
    private xDataType = DataType.String;
    private xSize = 0;
    private xCaption = '';
    private xColumnStyle = ColumnAppearance.Hidden;
    private xAlignment = FieldAlignment.Left;
    private xUpdateStyle = WidgetAppearance.Hidden;
    private xInsertStyle = WidgetAppearance.Hidden;
    private xDefaultValue = '';
    private xHint = '';
    private xOptions: Options = new Options();
    private xContext = '';

    // tslint:disable-next-line: max-line-length
    constructor(
        fieldname: string,
        datatype: DataType,
        caption?: string,
        columnStyle?: ColumnAppearance,
        alignment?: FieldAlignment,
        size?: number,
        hint?: string
    ) {
        this.xFieldName = fieldname;
        this.xDataType = datatype;
        if (size === undefined) {
            switch (this.xDataType) {
                case DataType.Guid:
                    this.xSize = 36;
                    break;
                case DataType.Boolean:
                    this.xSize = 1;
                    break;
                case DataType.Indicator:
                    this.xSize = 2;
                    break;
                case DataType.Integer:
                    this.xSize = 4;
                    break;
                case DataType.IMEI:
                    this.xSize = 15;
                    break;
                default:
                    this.xSize = 0;
                    break;
            }
        } else {
            this.xSize = size;
        }
        this.xCaption = caption || this.xFieldName;
        this.xColumnStyle = columnStyle || ColumnAppearance.Hidden;
        this.xAlignment = alignment || FieldAlignment.Left;
        this.xHint = hint || '';
    }
    public get fieldname() {
        return this.xFieldName;
    }
    public get dataType() {
        return this.xDataType;
    }
    public get size() {
        return this.xSize;
    }
    public get caption() {
        return this.xCaption;
    }
    public get columnStyle() {
        return this.xColumnStyle;
    }
    public get alignment() {
        return this.xAlignment;
    }
    public get updateStyle() {
        return this.xUpdateStyle;
    }
    public set updateStyle(value: WidgetAppearance) {
        this.xUpdateStyle = value;
    }
    public get insertStyle() {
        return this.xInsertStyle === undefined ? this.xUpdateStyle : this.xInsertStyle;
    }
    public set insertStyle(value: WidgetAppearance) {
        this.xInsertStyle = value;
    }
    public get defaultValue() {
        return this.xDefaultValue;
    }
    public set defaultValue(value: string) {
        this.xDefaultValue = value;
    }
    public get hint() {
        return this.xHint || this.xCaption.replace('.table.', '.hint');
    }
    public get options() {
        return this.xOptions;
    }
    public set options(value: Options) {
        this.xOptions = value;
    }
    public get context() {
        return this.xContext;
    }
    public set context(value: string) {
        this.xContext = value;
    }
    public get css(): string {
        const cssArray = ['text-xs-left', 'text-xs-right', 'text-xs-center'];
        return this.columnStyle >= ColumnAppearance.Visible ? cssArray[this.alignment] : 'none';
    }
}
